import { redirect } from 'react-router-dom';

/**
 * ActionSummaryLoader - Loader para la vista de detalle de una action
 *
 * @param request - Request object con la URL
 * @returns Objeto con el ID de la action
 */
export async function ActionSummaryLoader({ request }: { request: Request }) {
  const url = new URL(request.url);
  const pathSegments = url.pathname.split('/');
  const actionId = pathSegments[pathSegments.length - 1];

  if (!actionId) {
    return redirect('/work-orders/search-create-historical-action');
  }

  return {
    id: actionId,
  };
}
